import { FC } from 'react'

import style from '@src/components/Title/Title.module.scss'

type TitleProps = {
    title: string
}

export const Title: FC<TitleProps> = ({ title }) => (
  <div className={style.header}>
    <h1>
      {title}
    </h1>
  </div>
)
